export default function initBlogFilter() {
    const orderFilter = document.getElementById('blog-order-filter');
    const resultsContainer = document.getElementById('blog-posts-results');

    if (!orderFilter || !resultsContainer) {
        return;
    }

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;
    let featuredId = 0;

    // Get featured ID from the load more button if it exists
    const initialLoadMoreBtn = document.querySelector('.blog__load-more');
    if (initialLoadMoreBtn) {
        featuredId = parseInt(initialLoadMoreBtn.getAttribute('data-featured-id')) || 0;
        const initialMaxPages = parseInt(initialLoadMoreBtn.getAttribute('data-max-pages'));
        if (initialMaxPages) {
            maxPages = initialMaxPages;
        }
    }

    function getFilterValues() {
        return {
            order_by: orderFilter.value,
            featured_id: featuredId
        };
    }

    function filterBlogPosts() {
        if (isLoading) return;

        const filters = getFilterValues();

        // Add loading state
        resultsContainer.classList.add('blog__posts-results--loading');
        resultsContainer.setAttribute('aria-busy', 'true');
        isLoading = true;

        // Reset to page 1 when filtering
        currentPage = 1;

        // Make AJAX request
        fetch(blogFilter.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'filter_blog_posts',
                nonce: blogFilter.nonce,
                order_by: filters.order_by,
                featured_id: filters.featured_id,
                page: currentPage
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resultsContainer.innerHTML = data.data.html;
                maxPages = data.data.max_pages;

                // Add load more button if needed
                if (maxPages > currentPage) {
                    addLoadMoreButton();
                }
            } else {
                resultsContainer.innerHTML = '<p class="blog__error">An error occurred. Please try again.</p>';
            }
        })
        .catch(error => {
            console.error('Error filtering blog posts:', error);
            resultsContainer.innerHTML = '<p class="blog__error">An error occurred. Please try again.</p>';
        })
        .finally(() => {
            resultsContainer.classList.remove('blog__posts-results--loading');
            resultsContainer.setAttribute('aria-busy', 'false');
            isLoading = false;
        });
    }

    function loadMoreBlogPosts() {
        if (isLoading || currentPage >= maxPages) return;

        const loadMoreBtn = document.querySelector('.blog__load-more');
        if (!loadMoreBtn) return;

        const filters = getFilterValues();

        // Add loading state to button
        loadMoreBtn.classList.add('loading');
        loadMoreBtn.textContent = 'Loading...';
        loadMoreBtn.disabled = true;
        isLoading = true;

        // Increment page
        currentPage++;

        // Make AJAX request
        fetch(blogFilter.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_more_blog_posts',
                nonce: blogFilter.nonce,
                order_by: filters.order_by,
                featured_id: filters.featured_id,
                page: currentPage
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Find the list container and append new items
                const listContainer = resultsContainer.querySelector('.blog__posts-list');
                if (listContainer) {
                    // Create temporary container to parse HTML
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;

                    // Append each new item to the list
                    const newItems = tempDiv.querySelectorAll('.post-item');
                    newItems.forEach(item => {
                        listContainer.appendChild(item);
                    });
                }

                maxPages = data.data.max_pages;

                // Remove or update load more button
                if (currentPage >= maxPages) {
                    loadMoreBtn.remove();
                } else {
                    loadMoreBtn.classList.remove('loading');
                    loadMoreBtn.textContent = 'Load More Posts';
                    loadMoreBtn.disabled = false;
                }
            } else {
                console.error('Error loading more blog posts');
            }
        })
        .catch(error => {
            console.error('Error loading more blog posts:', error);
            currentPage--; // Revert page increment on error
        })
        .finally(() => {
            isLoading = false;
        });
    }

    function addLoadMoreButton() {
        const existingWrapper = resultsContainer.querySelector('.blog__load-more-wrapper');
        if (existingWrapper) {
            existingWrapper.remove();
        }

        const loadMoreWrapper = document.createElement('div');
        loadMoreWrapper.className = 'blog__load-more-wrapper';

        const loadMoreBtn = document.createElement('button');
        loadMoreBtn.type = 'button';
        loadMoreBtn.className = 'blog__load-more button button--purple';
        loadMoreBtn.textContent = 'Load More Posts';

        loadMoreBtn.addEventListener('click', loadMoreBlogPosts);

        loadMoreWrapper.appendChild(loadMoreBtn);
        resultsContainer.appendChild(loadMoreWrapper);
    }

    // Add event listener to order filter
    orderFilter.addEventListener('change', filterBlogPosts);

    // Initialize load more button if it exists on page load
    if (initialLoadMoreBtn) {
        initialLoadMoreBtn.addEventListener('click', loadMoreBlogPosts);
    }
}
